import ExistingInvestment from "./ExistingInvestment";
import ExistingInsurance from "./ExistingInsurance";

export default function CurrentPlans() {
  return (
    <>
      <ExistingInvestment />
      <ExistingInsurance />
    </>
  );
}
